import { useTranslation } from 'react-i18next'

import { ForgotPasswordForm } from '../Components/ForgotPasswordForm'
import { FormWrapper } from '../Components/FormWrapper'

const NS = 'Public.Auth'

export default function ForgotPasswordPage() {
    const { t } = useTranslation()
    document.title = t('Password recovery', { ns: NS })

    return (
        <FormWrapper
            title={t('Password recovery', { ns: NS })}
            subtitle={t('Enter the e-mail of your account and we will send a confirmation code.', { ns: NS })}
        >
            <ForgotPasswordForm />
        </FormWrapper>
    )
}
